/**
 *
 * Asynchronously loads the component for PresentRequestPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PresentRequestPage = lazyLoad(
  () => import('./index'),
  module => module.PresentRequestPage,
);
